import React, { useState, useEffect } from "react";
import { msalParams } from "../../Utility/msalConfig"; // Import the MSAL config
import * as msal from "@azure/msal-browser"; // Import MSAL for authentication
import { Pressable, VStack, Text } from 'native-base';
import onedriveIcon from "../../assets/images/onedriveIcon.png";
import { Loc } from "../../App/Loc";

const OneDrive = ({ setExternalLink, HandleAddOneDrive, setIsOneDriveData }) => {
    const [app, setApp] = useState<msal.PublicClientApplication | any>(null);
    const baseUrl = "https://onedrive.live.com/picker";

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://alcdn.msauth.net/browser/2.19.0/js/msal-browser.min.js";
        script.async = true;
        script.onload = apiLoaded;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const apiLoaded = () => {
        setApp(new msal.PublicClientApplication(msalParams));
    };

    const params = {
        sdk: "8.0",
        entry: {
            oneDrive: {
                files: {}
            }
        },
        authentication: {},
        messaging: {
            origin: window.location.origin,
            channelId: "27"
        },
        typesAndSources: {
            mode: "files",
            pivots: {
                oneDrive: true,
                recent: true
            }
        }
    };

    let win: Window | any;
    let port: MessagePort | any;

    async function launchPicker(e) {
        e.preventDefault();

        win = window.open("", "Picker", "height=600,width=1200");

        if (!win || win.closed || typeof win.closed === 'undefined' || win == null) {
            alert('Popup was blocked. Please allow popups for this site.');
            win.close();
            return;
        }

        const authToken = await getToken();

        const queryString = new URLSearchParams({
            filePicker: JSON.stringify(params)
        });

        const url = `${baseUrl}?${queryString}`;

        if (win) {
            const form = win.document.createElement("form");
            if (form) {
                form.setAttribute("action", url);
                form.setAttribute("method", "POST");
                win.document.body.appendChild(form);

                const input = win.document.createElement("input");
                input.setAttribute("type", "hidden");
                input.setAttribute("name", "access_token");
                input.setAttribute("value", authToken);
                form.appendChild(input);

                form.submit();
            } else {
                console.error("Failed to create form.");
            }
        } else {
            console.error("Failed to open the Picker window.");
        }

        window.addEventListener("message", (event) => {
            if (event.source && event.source === win) {
                const message = event.data;

                if (message.type === "initialize" && message.channelId === params.messaging.channelId) {
                    port = event.ports[0];

                    port.addEventListener("message", messageListener);

                    port.start();

                    port.postMessage({
                        type: "activate"
                    });
                }
            }
        });
    }

    const uploadFiles = async (commandData) => {
        try {
            const data = commandData.items[0];
            console.log("Selected file from OneDrive:", data);
    
            const token = await getToken();
            if (!token) {
                console.error("Failed to get token");
                return;
            }
    
            // Ensure endpoint ends with "/"
            let endpoint = data["@sharePoint.endpoint"];
            if (!endpoint.endsWith("/")) {
                endpoint += "/";
            }
    
            // Construct proper URL to download file content
            const url = `${endpoint}drives/${data.parentReference.driveId}/items/${data.id}/content`;
    
            console.log("Fetching from:", url);
    
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
    
            if (!response.ok) {
                const text = await response.text();
                console.error("Failed to fetch file content:", response.status, text);
                return;
            }
    
            // Get blob or ArrayBuffer depending on your need
            const blob = await response.blob();
    
            // process the blob based on content type
            const fileData = {
                name: data.name,
                type: blob.type,
                size: blob.size,
                blob: blob,
            };
    
            console.log("Selected file data:", fileData);
            setIsOneDriveData(fileData);
    
        } catch (err) {
            console.error("An error occurred:", err);
        }
    };

    async function messageListener(message) {
        switch (message.data.type) {
            case "notification":
                console.log(`notification: ${message.data}`);
                break;
            case "command":
                const command = message.data.data;
                switch (command.command) {
                    case "authenticate":
                        const token = await getToken();
                        if (token) {
                            console.log("authentication", token);
                            port.postMessage({
                                type: "result",
                                id: message.data.id,
                                data: { result: "token", token }
                            });
                        } else {
                            console.error(`Could not get auth token for command: ${JSON.stringify(command)}`);
                        }
                        break;

                    case "pick":
                        uploadFiles(command);
                        port.postMessage({
                            type: "result",
                            id: message.data.id,
                            data: { result: "success" }
                        });
                        win.close();
                        break;

                    default:
                        port.postMessage({
                            result: "error",
                            error: {
                                code: "unsupportedCommand",
                                message: command.command
                            },
                            isExpected: true
                        });
                        break;
                }
                break;
        }
    }

    async function getToken() {
        let accessToken = "";

        let authParams = { scopes: ["OneDrive.ReadWrite"] };

        try {
            // See if we have the idToken saved
            const resp = await app.acquireTokenSilent(authParams);
            accessToken = resp.accessToken;
        } catch (e) {
            try {
                win.close();
                const resp = await app.loginPopup(authParams);
                win = window.open("", "Picker", "height=600,width=1200");
                app.setActiveAccount(resp.account);
                if (resp.idToken) {
                    const resp2 = await app.acquireTokenSilent(authParams);
                    accessToken = resp2.accessToken;
                }
            } catch (e) {
                if (win.closed) {
                    alert('Popup was blocked. Please allow popups for this site.');
                    win.close();
                    return;
                }
            }
        }
        return accessToken;
    }

    return (
        <div>
            <Pressable onPress={launchPicker}>
                <VStack space={3}>
                    <img src={onedriveIcon} height={'32px'} width={'32px'} />
                    <Text>{Loc.currentLang.keyboardInsideTxt.oneDrive}</Text>
                </VStack>
            </Pressable>
        </div>
    );
};

export default OneDrive;
